var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DashboardCardScaffold",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "flex items-center" },
                [
                  _c("RecruitingIcon", {
                    staticClass: "h-8 w-8 fill-current text-primary-500 mr-2",
                  }),
                  _c(
                    "RouterLink",
                    {
                      staticClass: "hover:text-primary-500",
                      attrs: {
                        to: {
                          name: _vm.routes.RECRUITING_POSTINGS,
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "font-semibold text-base" }, [
                        _vm._v("Recruiting"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c("PostingModalWithButton", {
                staticClass: "flex flex-grow justify-end",
                attrs: {
                  companyId: _vm.companyId,
                  currentUser: _vm.currentUser,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "CardItemScaffold",
        {
          attrs: {
            itemNumber: _vm.postingsTotal,
            itemTitle: "Active Postings",
            flexRow: "",
          },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("JobPostingIcon", {
                    staticClass: "h-5 w-5 fill-current text-primary-500",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.postings.length
            ? _c(
                "div",
                { staticClass: "flex items-center" },
                _vm._l(_vm.postings, function (posting, index) {
                  return _c("CircleWithInitials", {
                    key: index,
                    staticClass: "mr-1",
                    attrs: {
                      showTooltip: "",
                      title: posting.name,
                      id: posting.id,
                      route: _vm.routes.RECRUITING_POSTING,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "CardItemScaffold",
        {
          attrs: {
            itemNumber: _vm.newPostingsTotal,
            itemTitle: "New Postings",
            flexRow: "",
          },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("JobPostingIcon", {
                    staticClass: "h-5 w-5 fill-current text-primary-500",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.newPostings.length
            ? _c(
                "div",
                { staticClass: "flex items-center" },
                _vm._l(_vm.newPostings, function (posting, index) {
                  return _c("CircleWithInitials", {
                    key: index,
                    staticClass: "mr-1",
                    attrs: {
                      showTooltip: "",
                      title: posting.name,
                      id: posting.id,
                      route: _vm.routes.RECRUITING_POSTING,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ]
      ),
      _c("CardItemScaffold", {
        attrs: {
          itemNumber: _vm.applicantsTotal,
          itemTitle: "Applicants",
          flexRow: "",
        },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [
                _c("SimplePersonIcon", {
                  staticClass: "h-5 w-5 fill-current text-primary-500",
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }